import image from "./images/i5.jpg"
function About() {
    return (
        <div className="container mt-5">
            <h1 className="text-center mb-4">About Us</h1>
            <p className="lead text-center">
                Welcome to our store! 🎉
            </p>
            <p className="text-muted text-center">
                We provide a wide range of high-quality products at the best prices.  
                Our mission is to make online shopping easy and enjoyable for everyone.  
            </p>
            <div className="text-center mt-4">
                <img 
                    src={image}
                    alt="About illustration" 
                    className="img-fluid rounded shadow"
                />
            </div>
        </div>
    );
}

export default About;
